var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxBarChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#193560",
    fillRule: "nonzero",
    d: "M21.263 18.012h-.889V4.108c0-.6-.489-1.089-1.09-1.089h-1.986c-.6 0-1.089.489-1.089 1.09v13.903h-2.256V9.955c0-.6-.489-1.09-1.09-1.09h-1.986c-.6 0-1.09.49-1.09 1.09v8.057H7.532v-4.655c0-.6-.489-1.089-1.09-1.089H4.456c-.6 0-1.089.489-1.089 1.09v4.654H2.43a.405.405 0 1 0 0 .81h18.833a.405.405 0 1 0 0-.81z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxBarChartIcon);
export default __webpack_public_path__ + "static/media/rx-bar-chart-icon.2091999435defa61eff78b03b7af6d7d.svg";
export { ForwardRef as ReactComponent };